import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

class BackButton extends PureComponent {
    goBack = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <button className="button __back" onClick={this.goBack}>
                Back
            </button>
        )
    }
}

export default withRouter(BackButton);



// WEBPACK FOOTER //
// ./src/components/BackButton.js